var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 11
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5781be",
  fillRule: "evenodd",
  d: "M4.086 5.5.293 1.707A1 1 0 1 1 1.707.293L5.5 4.086 9.293.293a1 1 0 0 1 1.414 1.414L6.914 5.5l3.793 3.793a1 1 0 1 1-1.414 1.414L5.5 6.914l-3.793 3.793A1 1 0 1 1 .293 9.293z"
})));
export default SvgClose;